import { useState, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';

import 'react-html5-camera-photo/build/css/index.css';

import { getStyled } from './styles';

Modal.setAppElement('#root');

const ModalCamera = ({ isOpen, onRequestClose, onCapture }) => {
  const classes = getStyled();

  const [capturedImage, setCapturedImage] = useState(null);
  const [isCameraReady, setIsCameraReady] = useState(false);

  const handleAfterOpen = useCallback(() => {
    setTimeout(() => setIsCameraReady(true), 50);
  }, []);

  const handleAfterClose = useCallback(() => {
    setIsCameraReady(false);
    setCapturedImage(null);
  }, []);

  const handleClose = useCallback(() => {
    onRequestClose();
  }, [onRequestClose]);

  const handleTakePhoto = useCallback((dataUri) => {
    setCapturedImage(dataUri);
  }, []);

  useEffect(() => {
    if (!capturedImage) return;

    const handleConfirm = async () => {
      try {
        const res = await fetch(capturedImage);
        const blob = await res.blob();
        onCapture(blob);
      } catch (err) {
        console.error(err);
      } finally {
        setCapturedImage(null);
        handleClose();
      }
    };

    handleConfirm();
  }, [capturedImage, onCapture, handleClose]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      onAfterOpen={handleAfterOpen}
      onAfterClose={handleAfterClose}
      style={classes.overlay}
    >
      <div style={{ flex: 1 }}>
        {isCameraReady && (
          <Camera
            onTakePhoto={handleTakePhoto}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            isImageMirror={false}
            style={classes.content}
          />
        )}
      </div>
    </Modal>
  );
};

export default ModalCamera;
